/**
 * "Create model" entry point, driven by the product registry.
 *
 * Each product owns a route whose model-less form means "new" (see
 * ProductEditorRoute in App.jsx), so creating one is just navigating there.
 * Listing the products from PRODUCTS rather than hardcoding them means a third
 * editor shows up here on its own.
 *
 * With a single product it renders a plain button, so nothing changes for a
 * deployment that only has the keyring enabled.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown, Plus } from 'lucide-react';
import { PRODUCTS } from '../../../../products/registry';

const CrearModeloButton = ({ className = '', size = 'md' }) => {
    const navigate = useNavigate();
    const products = Object.values(PRODUCTS);
    const buttonSize = size === 'sm' ? 'btn-sm' : '';

    if (products.length === 1) {
        return (
            <button
                className={`btn btn-primary ${buttonSize} ${className}`}
                onClick={() => navigate(products[0].routeBase)}
            >
                <Plus className="w-5 h-5 mr-2" />
                Crear modelo
            </button>
        );
    }

    return (
        <div className={`dropdown dropdown-end ${className}`}>
            <div
                tabIndex={0}
                role="button"
                className={`btn btn-primary ${buttonSize} gap-1`}
            >
                <Plus className="w-5 h-5" />
                Crear modelo
                <ChevronDown className="w-4 h-4 opacity-70" />
            </div>
            <ul
                tabIndex={0}
                className="dropdown-content z-50 menu p-2 shadow-lg bg-base-100 rounded-box w-56 mt-1"
            >
                {products.map((product) => (
                    <li key={product.key}>
                        <button
                            type="button"
                            onClick={() => {
                                // Close the dropdown: DaisyUI keeps it open while
                                // the trigger holds focus.
                                document.activeElement?.blur();
                                navigate(product.routeBase);
                            }}
                        >
                            {product.label}
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CrearModeloButton;
